// [TODO] - To replace - Alucio Blue - Primary 44A2DA
export const colorsDef = {
    // --------------------------------UI2 START--------------------------------
    // UI2 BRAND
    'ui2-brand-950': '#1E1B4B',
    'ui2-brand-900': '#312E81',
    'ui2-brand-800': '#3730A3',
    'ui2-brand-700': '#4338CA',
    'ui2-brand-600': '#4F46E5',
    'ui2-brand-500': '#6366F1',
    'ui2-brand-400': '#818CF8',
    'ui2-brand-300': '#A5B4FC',
    'ui2-brand-200': '#C7D2FE',
    'ui2-brand-100': '#E0E7FF',
    'ui2-brand-50': '#EEF2FF',
    'ui2-brand-transparent-16': 'rgba(79, 70, 229, 0.16)',
    'ui2-brand-transparent-8': 'rgba(79, 70, 229, 0.08)',
    'ui2-brand-transparent-40': 'rgba(99, 102, 241, 0.4)',
    'ui2-brand-transparent-56': 'rgba(99, 102, 241, 0.56)',
    // UI2 NEUTRAL
    'ui2-neutral-950': '#020617',
    'ui2-neutral-900': '#0F172A',
    'ui2-neutral-800': '#1E293B',
    'ui2-neutral-700': '#334155',
    'ui2-neutral-600': '#475569',
    'ui2-neutral-500': '#64748B',
    'ui2-neutral-400': '#94A3B8',
    'ui2-neutral-300': '#CBD5E1',
    'ui2-neutral-200': '#E2E8F0',
    'ui2-neutral-100': '#F1F5F9',
    'ui2-neutral-50': '#F8FAFC',
    'ui2-neutral-transparent-8': 'rgba(15, 23, 42, 0.08)',
    'ui2-neutral-transparent-16': 'rgba(15, 23, 42, 0.16)',
    'ui2-neutral-transparent-24': 'rgba(15, 23, 42, 0.24)',
    'ui2-neutral-transparent-32': 'rgba(15, 23, 42, 0.32)',
    'ui2-neutral-transparent-40': 'rgba(15, 23, 42, 0.4)',
    'ui2-neutral-transparent-48': 'rgba(15, 23, 42, 0.48)',
    'ui2-neutral-transparent-56': 'rgba(15, 23, 42, 0.56)',
    'ui2-neutral-transparent-64': 'rgba(15, 23, 42, 0.64)',
    'ui2-neutral-transparent-72': 'rgba(15, 23, 42, 0.72)',
    'ui2-neutral-transparent-80': 'rgba(15, 23, 42, 0.8)',
    'ui2-neutral-transparent-88': 'rgba(15, 23, 42, 0.88)',
    // UI2 SUCCESS
    'ui2-success-950': '#052920',
    'ui2-success-900': '#0C4838',
    'ui2-success-800': '#0D5843',
    'ui2-success-700': '#0E6E53',
    'ui2-success-600': '#118A64',
    'ui2-success-500': '#22C38E',
    'ui2-success-400': '#41C695',
    'ui2-success-300': '#78DDB5',
    'ui2-success-200': '#ADEDD0',
    'ui2-success-100': '#D4F7E5',
    'ui2-success-50': '#EDFCF5',
    'ui2-success-transparent-40': 'rgba(34, 195, 142, 0.4)',
    'ui2-success-transparent-56': 'rgba(34, 195, 142, 0.56)',
    // UI2 WARNING
    'ui2-warning-950': '#441806',
    'ui2-warning-900': '#7E3610',
    'ui2-warning-800': '#9C3F10',
    'ui2-warning-700': '#C55109',
    'ui2-warning-600': '#EE6B08',
    'ui2-warning-500': '#FD8208',
    'ui2-warning-400': '#FEA339',
    'ui2-warning-300': '#FFC672',
    'ui2-warning-200': '#FFDFA8',
    'ui2-warning-100': '#FFF1D4',
    'ui2-warning-50': '#FFF9ED',
    'ui2-warning-transparent-40': 'rgba(253, 130, 8, 0.4)',
    'ui2-warning-transparent-56': 'rgba(253, 130, 8, 0.56)',
    // UI2 DANGER
    'ui2-danger-950': '#4C0525',
    'ui2-danger-900': '#89124A',
    'ui2-danger-800': '#A01150',
    'ui2-danger-700': '#BF1157',
    'ui2-danger-600': '#E21C67',
    'ui2-danger-500': '#F4256A',
    'ui2-danger-400': '#FC709B',
    'ui2-danger-300': '#FEA3BE',
    'ui2-danger-200': '#FECDDB',
    'ui2-danger-100': '#FFE4EA',
    'ui2-danger-50': '#FFF1F4',
    'ui2-danger-transparent-40': 'rgba(244, 37, 106, 0.4)',
    'ui2-danger-transparent-56': 'rgba(244, 37, 106, 0.56)',
    // UI2 TEXT LIGHT THEME
    'text-light-primary': '#0F172A',
    'text-light-secondary': '#334155',
    'text-light-tertiary': '#64748B',
    'text-light-subtle': '#94A3B8',
    // UI2 TEXT DARK THEME
    'text-dark-primary': '#FFFFFF',
    'text-dark-secondary': '#94A3B8',
    // [UI2-TODO] - NOT IMPLEMENTED BUT AVOID BREAKING PROP USAGE BY HAVING USABLE VALUES
    'text-dark-tertiary': 'red',
    'text-dark-subtle': 'red',
    // UI2 BORDER LIGHT THEME
    'border-light-primary': '#E2E8F0',
    'border-light-secondary': '#F1F5F9',
    // UI2 BORDER DARK THEME
    'border-dark-primary': '#334155',
    'border-dark-secondary': '#475569',
    // OTHER COLORS
    'white': '#FFFFFF',
    'white-transparent-6': 'rgba(255, 255, 255, 0.06)',
    'white-transparent-8': 'rgba(255, 255, 255, 0.08)',
    'white-transparent-16': 'rgba(255, 255, 255, 0.16)',
    'white-transparent-24': 'rgba(255, 255, 255, 0.24)',
    'white-transparent-32': 'rgba(255, 255, 255, 0.32)',
    'white-transparent-80': 'rgba(255, 255, 255, 0.8)',
    'black': '#000000',
    // NEW (KENNY)
    'black-transparent-45': 'rgba(0, 0, 0, 0.45)',
    'black-transparent-50': 'rgba(0, 0, 0, 0.5)',
    'black-transparent-60': 'rgba(0, 0, 0, 0.6)',
    'notation-yellow-dot': '#FFE81E',
    'tooltip-background': '#2C3651',
    // ---------------------------------UI2 END---------------------------------
};
export const UICutoverMappings = {
    // PRIMARY (BRAND)
    // Primary is old colors, kept for now. It is used in DNAChip/light.json
    // ASSUMING PRIMARY === BRAND
    // MISSING 50 and 950
    'primary-100': colorsDef['ui2-brand-100'],
    'primary-200': colorsDef['ui2-brand-200'],
    'primary-300': colorsDef['ui2-brand-300'],
    'primary-400': colorsDef['ui2-brand-400'],
    // SlidesGroupTarget - container group borderColor
    'primary-500': colorsDef['ui2-brand-500'],
    // CollapsibleCard - Selected border
    // Hubs - Link (text) color
    // Slide Versioning - All slides have "matched" (color) to the previous version
    // Slide Grouping - For further information including step-by-step instructions, click "here" (color) to access the full help article.
    'primary-600': colorsDef['ui2-brand-600'],
    'primary-700': colorsDef['ui2-brand-700'],
    'primary-800': colorsDef['ui2-brand-800'],
    'primary-900': colorsDef['ui2-brand-900'],
    'primary-transparent-100': colorsDef['ui2-brand-transparent-40'],
    'primary-transparent-200': colorsDef['ui2-brand-transparent-40'],
    'primary-transparent-300': colorsDef['ui2-brand-transparent-40'],
    'primary-transparent-400': colorsDef['ui2-brand-transparent-40'],
    'primary-transparent-500': colorsDef['ui2-brand-transparent-40'],
    'primary-transparent-600': colorsDef['ui2-brand-transparent-40'],
    // BRAND1
    'brand1-900': colorsDef['ui2-brand-900'],
    'brand1-800': colorsDef['ui2-brand-800'],
    'brand1-700': colorsDef['ui2-brand-700'],
    'brand1-600': colorsDef['ui2-brand-600'],
    'brand1-500': colorsDef['ui2-brand-500'],
    'brand1-400': colorsDef['ui2-brand-400'],
    'brand1-300': colorsDef['ui2-brand-300'],
    'brand1-200': colorsDef['ui2-brand-200'],
    'brand1-100': colorsDef['ui2-brand-100'],
    'brand1-80': colorsDef['ui2-brand-100'],
    'brand1-50': colorsDef['ui2-brand-50'],
    'brand1-20': colorsDef['ui2-brand-50'],
    'brand1-10': colorsDef['ui2-brand-50'],
    'brand1-5': colorsDef['ui2-brand-50'],
    'brand1-transparent-40': colorsDef['ui2-brand-transparent-40'],
    'brand1-transparent-56': colorsDef['ui2-brand-transparent-56'],
    // BRAND2
    // NO NEW BRAND2 EQUIV
    'brand2-900': colorsDef['ui2-brand-900'],
    'brand2-800': colorsDef['ui2-brand-800'],
    'brand2-700': colorsDef['ui2-brand-700'],
    'brand2-600': colorsDef['ui2-brand-600'],
    'brand2-500': colorsDef['ui2-brand-500'],
    'brand2-400': colorsDef['ui2-brand-400'],
    'brand2-300': colorsDef['ui2-brand-300'],
    'brand2-200': colorsDef['ui2-brand-200'],
    'brand2-100': colorsDef['ui2-brand-100'],
    'brand2-80': colorsDef['ui2-brand-100'],
    'brand2-50': colorsDef['ui2-brand-50'],
    'brand2-20': colorsDef['ui2-brand-50'],
    'brand2-10': colorsDef['ui2-brand-50'],
    'brand2-5': colorsDef['ui2-brand-50'],
    'brand2-transparent-40': colorsDef['ui2-brand-transparent-40'],
    'brand2-transparent-56': colorsDef['ui2-brand-transparent-56'],
    // TEXT COLORS
    'text-primary': colorsDef['text-light-primary'],
    'text-secondary': colorsDef['text-light-secondary'],
    'text-subtle': colorsDef['text-light-subtle'],
    'text-basic': colorsDef['white'],
    // // TEXT COLORS (This is the new color)
    // 'text-primary': '#1D1D1D',
    // 'text-secondary': '#494949',
    'text-tertiary': 'ui2-neutral-500',
    // 'text-subtle': '#929292',
    'text-extra-subtle': 'ui2-neutral-400',
    'text-white': 'white',
    // GRAY
    'gray-900': colorsDef['ui2-neutral-900'],
    'gray-800': colorsDef['ui2-neutral-800'],
    'gray-700': colorsDef['ui2-neutral-700'],
    'gray-600': colorsDef['ui2-neutral-600'],
    'gray-500': colorsDef['ui2-neutral-500'],
    'gray-400': colorsDef['ui2-neutral-400'],
    // 'gray-300': colorsDef['ui2-neutral-300'],
    'gray-300': colorsDef['ui2-neutral-500'],
    'gray-200': colorsDef['ui2-neutral-200'],
    'gray-100': colorsDef['ui2-neutral-100'],
    'gray-80': colorsDef['ui2-neutral-100'],
    'gray-50': colorsDef['ui2-neutral-50'],
    'gray-20': colorsDef['ui2-neutral-50'],
    'gray-10': colorsDef['ui2-neutral-50'],
    'gray-5': colorsDef['ui2-neutral-50'],
    'gray-transparent-40': colorsDef['ui2-neutral-transparent-40'],
    'gray-transparent-56': colorsDef['ui2-neutral-transparent-56'],
    'black-transparent-40': colorsDef['ui2-neutral-transparent-40'],
    'black-transparent-56': colorsDef['ui2-neutral-transparent-56'],
    // INFO
    // Most similar to Brand byt off from brand
    'info-900': colorsDef['ui2-brand-900'],
    'info-800': colorsDef['ui2-brand-800'],
    'info-700': colorsDef['ui2-brand-700'],
    'info-600': colorsDef['ui2-brand-600'],
    'info-500': colorsDef['ui2-brand-500'],
    'info-400': colorsDef['ui2-brand-400'],
    'info-300': colorsDef['ui2-brand-300'],
    'info-200': colorsDef['ui2-brand-200'],
    'info-100': colorsDef['ui2-brand-100'],
    'info-80': colorsDef['ui2-brand-100'],
    'info-50': colorsDef['ui2-brand-50'],
    'info-20': colorsDef['ui2-brand-50'],
    'info-10': colorsDef['ui2-brand-50'],
    'info-5': colorsDef['ui2-brand-50'],
    'info-transparent-40': colorsDef['ui2-brand-transparent-40'],
    'info-transparent-56': colorsDef['ui2-brand-transparent-56'],
    // SUCCESS
    'success-900': colorsDef['ui2-success-900'],
    'success-800': colorsDef['ui2-success-800'],
    'success-700': colorsDef['ui2-success-700'],
    'success-600': colorsDef['ui2-success-600'],
    'success-500': colorsDef['ui2-success-500'],
    'success-400': colorsDef['ui2-success-400'],
    'success-300': colorsDef['ui2-success-300'],
    'success-200': colorsDef['ui2-success-200'],
    'success-100': colorsDef['ui2-success-100'],
    'success-80': colorsDef['ui2-success-100'],
    'success-50': colorsDef['ui2-success-50'],
    'success-20': colorsDef['ui2-success-50'],
    'success-10': colorsDef['ui2-success-50'],
    'success-5': colorsDef['ui2-success-50'],
    'success-transparent-40': colorsDef['ui2-success-transparent-40'],
    'success-transparent-56': colorsDef['ui2-success-transparent-56'],
    // WARNING
    'warning-900': colorsDef['ui2-warning-900'],
    'warning-800': colorsDef['ui2-warning-800'],
    'warning-700': colorsDef['ui2-warning-700'],
    'warning-600': colorsDef['ui2-warning-600'],
    'warning-500': colorsDef['ui2-warning-500'],
    'warning-400': colorsDef['ui2-warning-400'],
    'warning-300': colorsDef['ui2-warning-300'],
    'warning-200': colorsDef['ui2-warning-200'],
    'warning-100': colorsDef['ui2-warning-100'],
    'warning-80': colorsDef['ui2-warning-100'],
    'warning-50': colorsDef['ui2-warning-50'],
    'warning-20': colorsDef['ui2-warning-50'],
    'warning-10': colorsDef['ui2-warning-50'],
    'warning-5': colorsDef['ui2-warning-50'],
    'warning-transparent-40': colorsDef['ui2-warning-transparent-40'],
    'warning-transparent-56': colorsDef['ui2-warning-transparent-56'],
    // DANGER
    'danger-900': colorsDef['ui2-danger-900'],
    'danger-800': colorsDef['ui2-danger-800'],
    'danger-700': colorsDef['ui2-danger-700'],
    'danger-600': colorsDef['ui2-danger-600'],
    'danger-500': colorsDef['ui2-danger-500'],
    'danger-400': colorsDef['ui2-danger-400'],
    'danger-300': colorsDef['ui2-danger-300'],
    'danger-200': colorsDef['ui2-danger-200'],
    'danger-100': colorsDef['ui2-danger-100'],
    'danger-80': colorsDef['ui2-danger-100'],
    'danger-50': colorsDef['ui2-danger-50'],
    'danger-20': colorsDef['ui2-danger-50'],
    'danger-10': colorsDef['ui2-danger-50'],
    'danger-5': colorsDef['ui2-danger-50'],
    'danger-transparent-40': colorsDef['ui2-danger-transparent-40'],
    'danger-transparent-56': colorsDef['ui2-danger-transparent-56'],
    // application background
    'application-background': colorsDef['white'],
};
const legacyColors = {
    // PRIMARY (BRAND)
    // Primary is old colors, kept for now. It is used in DNAChip/light.json
    'primary-100': '#DAF8FD',
    'primary-200': '#B6EEFB',
    'primary-300': '#8FDAF3',
    'primary-400': '#70C3E8',
    'primary-500': '#44A2DA',
    'primary-600': '#317FBB',
    'primary-700': '#22609C',
    'primary-800': '#15447E',
    'primary-900': '#0D3068',
    'primary-transparent-100': 'rgba(68, 162, 218, 0.08)',
    'primary-transparent-200': 'rgba(68, 162, 218, 0.16)',
    'primary-transparent-300': 'rgba(68, 162, 218, 0.24)',
    'primary-transparent-400': 'rgba(68, 162, 218, 0.32)',
    'primary-transparent-500': 'rgba(68, 162, 218, 0.4)',
    'primary-transparent-600': 'rgba(68, 162, 218, 0.48)',
    // BRAND1
    'brand1-900': '#2F143D',
    'brand1-800': '#371847',
    'brand1-700': '#3F1B51',
    'brand1-600': '#471F5B',
    'brand1-500': '#4F2265',
    'brand1-400': '#613874',
    'brand1-300': '#724E84',
    'brand1-200': '#846493',
    'brand1-100': '#957AA3',
    'brand1-80': '#A791B2',
    'brand1-50': '#B9A7C1',
    'brand1-20': '#CABDD1',
    'brand1-10': '#DCD3E0',
    'brand1-5': '#EDE9F0',
    'brand1-transparent-40': 'rgba(79, 34, 101, 0.4)',
    'brand1-transparent-56': 'rgba(79, 34, 101, 0.56)',
    // BRAND2
    'brand2-900': '#22516D',
    'brand2-800': '#296183',
    'brand2-700': '#3682AE',
    'brand2-600': '#3D92C4',
    'brand2-500': '#44A2DA',
    'brand2-400': '#57ABDE',
    'brand2-300': '#69B5E1',
    'brand2-200': '#7CBEE5',
    'brand2-100': '#8FC7E9',
    'brand2-80': '#A2D1ED',
    'brand2-50': '#B4DAF0',
    'brand2-20': '#C7E3F4',
    'brand2-10': '#DAECF8',
    'brand2-5': '#ECF6FB',
    'brand2-transparent-40': 'rgba(68, 162, 218, 0.4)',
    'brand2-transparent-56': 'rgba(68, 162, 218, 0.56)',
    // TEXT COLORS
    // (This is the old colors, we will replace it for a text-color-update ticket)
    'text-primary': '#312039',
    'text-secondary': '#766A7B',
    'text-subtle': '#BAB5BD',
    'text-basic': '#FFFFFF',
    // // TEXT COLORS (This is the new color)
    // 'text-primary': '#1D1D1D',
    // 'text-secondary': '#494949',
    'text-tertiary': '#6D6D6D',
    // 'text-subtle': '#929292',
    'text-extra-subtle': '#B6B6B6',
    'text-white': '#FFFFFF',
    // GRAY
    'gray-900': '#0F0F0F',
    'gray-800': '#1D1D1D',
    'gray-700': '#2C2C2C',
    'gray-600': '#3A3A3A',
    'gray-500': '#494949',
    'gray-400': '#6D6D6D',
    'gray-300': '#929292',
    'gray-200': '#B6B6B6',
    'gray-100': '#DBDBDB',
    'gray-80': '#EBEBEB',
    'gray-50': '#F1F1F1',
    'gray-20': '#F4F4F4',
    'gray-10': '#F8F8F8',
    'gray-5': '#FCFCFC',
    'gray-transparent-40': 'rgba(73, 73, 73, 0.4)',
    'gray-transparent-56': 'rgba(73, 73, 73, 0.56)',
    'black-transparent-40': 'rgba(0, 0, 0, 0.4)',
    'black-transparent-56': 'rgba(0, 0, 0, 0.56)',
    // INFO
    'info-900': '#1F4C71',
    'info-800': '#245984',
    'info-700': '#296697',
    'info-600': '#2E72AA',
    'info-500': '#337FBD',
    'info-400': '#478CC4',
    'info-300': '#5C99CA',
    'info-200': '#70A5D1',
    'info-100': '#85B2D7',
    'info-80': '#99BFDE',
    'info-50': '#ADCCE5',
    'info-20': '#C2D9EB',
    'info-10': '#D6E5F2',
    'info-5': '#EBF2F8',
    'info-transparent-40': 'rgba(51, 127, 189, 0.4)',
    'info-transparent-56': 'rgba(51, 127, 189, 0.56)',
    // SUCCESS
    'success-900': '#1D684C',
    'success-800': '#227959',
    'success-700': '#268A66',
    'success-600': '#2B9C72',
    'success-500': '#30AD7F',
    'success-400': '#45B58C',
    'success-300': '#59BD99',
    'success-200': '#6EC6A5',
    'success-100': '#83CEB2',
    'success-80': '#98D6BF',
    'success-50': '#ACDECC',
    'success-20': '#C1E6D9',
    'success-10': '#D6EFE5',
    'success-5': '#EAF7F2',
    'success-transparent-40': 'rgba(48, 173, 127, 0.4)',
    'success-transparent-56': 'rgba(48, 173, 127, 0.56)',
    // WARNING
    'warning-900': '#93611F',
    'warning-800': '#AC7124',
    'warning-700': '#C48129',
    'warning-600': '#DD912E',
    'warning-500': '#F5A133',
    'warning-400': '#F6AA47',
    'warning-300': '#F7B45C',
    'warning-200': '#F8BD70',
    'warning-100': '#F9C785',
    'warning-80': '#FAD099',
    'warning-50': '#FBD9AD',
    'warning-20': '#FCE3C2',
    'warning-10': '#FDECD6',
    'warning-5': '#FEF6EB',
    'warning-transparent-40': 'rgba(245, 161, 51, 0.4)',
    'warning-transparent-56': 'rgba(245, 161, 51, 0.56)',
    // DANGER
    'danger-900': '#7A221D',
    'danger-800': '#8E2722',
    'danger-700': '#A22D27',
    'danger-600': '#B7322C',
    'danger-500': '#CB3831',
    'danger-400': '#D04C46',
    'danger-300': '#D5605A',
    'danger-200': '#DB746F',
    'danger-100': '#E08883',
    'danger-80': '#E59C98',
    'danger-50': '#EAAFAD',
    'danger-20': '#EFC3C1',
    'danger-10': '#F5D7D6',
    'danger-5': '#FAEBEA',
    'danger-transparent-40': 'rgba(203, 56, 49, 0.4)',
    'danger-transparent-56': 'rgba(203, 56, 49, 0.56)',
    // application background
    'application-background': 'white',
};
export const cutoverDef = {
    ...colorsDef,
    ...UICutoverMappings,
};
// Prefix `color-`
export const colors = Object
    .entries(cutoverDef)
    .reduce((acc, [key, val]) => ({ ...acc, [`color-${key}`]: val }), {});
export default colors;
//# sourceMappingURL=colors.js.map